import { render, staticRenderFns } from "./OffcanvaBody.vue?vue&type=template&id=6b38eaf5&"
import script from "./OffcanvaBody.vue?vue&type=script&lang=js&"
export * from "./OffcanvaBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports